/**
 * @generated SignedSource<<6417863805595bd71a830a4fa464b6fb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateWeightableInput = {
  clientMutationId?: string | null;
  weightableId: string;
  weight: number;
};
export type ChatbotDetailPageContainer_updateDeliverWeightMutation$variables = {
  input: UpdateWeightableInput;
};
export type ChatbotDetailPageContainer_updateDeliverWeightMutationVariables = ChatbotDetailPageContainer_updateDeliverWeightMutation$variables;
export type ChatbotDetailPageContainer_updateDeliverWeightMutation$data = {
  readonly updateWeightable: {
    readonly weightable: {
      readonly id: string;
      readonly weight: number;
    };
  } | null;
};
export type ChatbotDetailPageContainer_updateDeliverWeightMutationResponse = ChatbotDetailPageContainer_updateDeliverWeightMutation$data;
export type ChatbotDetailPageContainer_updateDeliverWeightMutation = {
  variables: ChatbotDetailPageContainer_updateDeliverWeightMutationVariables;
  response: ChatbotDetailPageContainer_updateDeliverWeightMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "weight",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ChatbotDetailPageContainer_updateDeliverWeightMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateWeightablePayload",
        "kind": "LinkedField",
        "name": "updateWeightable",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "weightable",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ChatbotDetailPageContainer_updateDeliverWeightMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateWeightablePayload",
        "kind": "LinkedField",
        "name": "updateWeightable",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "weightable",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "616eec59752193d04d07d797d506d2d8",
    "id": null,
    "metadata": {},
    "name": "ChatbotDetailPageContainer_updateDeliverWeightMutation",
    "operationKind": "mutation",
    "text": "mutation ChatbotDetailPageContainer_updateDeliverWeightMutation(\n  $input: UpdateWeightableInput!\n) {\n  updateWeightable(input: $input) {\n    weightable {\n      __typename\n      id\n      weight\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "bd023a594c797a7754b8e9659497e561";

export default node;
